// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2d7fb705","455":"4e5dc88d"}[chunkId] + ".chunk.js";
};